import { render, staticRenderFns } from "./TertiaryButton.vue?vue&type=template&id=3ed29bd2&scoped=true&"
import script from "./TertiaryButton.vue?vue&type=script&lang=js&"
export * from "./TertiaryButton.vue?vue&type=script&lang=js&"
import style0 from "./TertiaryButton.vue?vue&type=style&index=0&id=3ed29bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed29bd2",
  null
  
)

export default component.exports